import { CommonModule } from '@angular/common';
import {
  Component,
  Inject,
  inject,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { NgToastService } from 'ng-angular-popup';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,

} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DataService } from '@/app/services/shared/stage2.service';
import { DialogboxComponent } from '@/app/components/projects/project-stages/plan-sections/dialogbox/dialogbox.component';
// import { AccordionComponent } from "../../../accordion/accordion.component";
interface WorkPackage {
  id: number;
  name: string;
  isSelected: boolean;
}

@Component({
  selector: 'app-manual-generated',
  standalone: true,
  imports: [MatIcon, CommonModule, FormsModule,  MatButtonModule,MatDialogModule],
  templateUrl: './manual-generated.component.html',
  styleUrl: './manual-generated.component.css',
})
export class ManualGeneratedComponent implements OnInit {
  keywords: WorkPackage[] = []; // Array of work packages
  WPS: any;
  WPSI: any;
  filteredWPS: any[] = []; // Holds filtered data
  selectedKeyword: WorkPackage | null = null; // Stores the selected work package
  constructor(
    private location: Location,
    private projectsService: ProjectsService,
    private toast: NgToastService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getAllWPS();
    this.getAllWPSI();
  }

  getAllWPS(): void {
    this.projectsService.getAllWPS().subscribe({
      next: (data) => {
        this.WPS = data.data;
        this.applyFiltering(); // Call filtering once WPS is loaded
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error fetching WPS:', error);
      },
    });
  }

  getAllWPSI(): void {
    this.projectsService.getAllWPSI().subscribe({
      next: (data) => {
        this.WPSI = data.data;
        this.applyFiltering();
      },
      error: (error) => {
        console.error('Error fetching WPSI:', error);
      },
    });
  }

  applyFiltering(): void {
    if (this.WPS && this.WPSI) {
      this.filteredWPS = this.WPS.map((keyword: any) => {
        const relatedItems = this.WPSI.filter(
          (wpsItem: any) => wpsItem.work_package_standard_id === keyword.id
        );
        return { ...keyword, relatedItems }; // Add relatedItems to the keyword object
      });
    }
  }

  // Add keyword (work package) entered by user
  addKeyword(inputField: HTMLInputElement): void {
    const keyword = inputField.value.trim();
    if (keyword) {
      const dataToSubmit = new FormData();
      dataToSubmit.append('name', keyword);
      dataToSubmit.append('is_custom', '1');

      this.projectsService.addWorkPackageStandard(dataToSubmit).subscribe({
        next: (response: any) => {
          this.toast.success(
            'Work Package created successfully',
            'SUCCESS',
            4000
          );
          if (response) {
            // this.keywords.push({id: name: keyword, isSelected: false });
            this.getAllWPS();
          }
        },
        error: (error: any) => {
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    }
    inputField.value = '';
  }

  add(): void {
    const dialogRef = this.dialog.open(DialogboxComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog closed with result:', result);
    });
    // if (this.selectedKeyword) {
    //   const selectedWPSId = this.selectedKeyword.id;

    //   // Make the API call to delete the selected work package by ID
    //   this.projectsService.deleteWorkPackageStandard(selectedWPSId).subscribe({
    //     next: (response: any) => {
    //       this.toast.success(
    //         'Work Package deleted successfully',
    //         'SUCCESS',
    //         4000
    //       );
    //       // Refresh the WPS list after deletion
    //       this.getAllWPS();
    //     },
    //     error: (error: any) => {
    //       this.toast.danger(error.error.message, 'DANGER', 4000);
    //     },
    //   });
    // } else {
    //   this.toast.warning(
    //     'Please select a work package to delete.',
    //     'WARNING',
    //     4000
    //   );
    // }
  }

  // Navigate to the next step (Cost Estimation)
  navigateCostEstimation() {
    if (this.selectedKeyword) {
      const selectedWPSId = this.selectedKeyword.id;

      const selectedWPSIItems = this.WPSI.filter(
        (wpsItem: any) => wpsItem.work_package_standard_id === selectedWPSId
      );
      this.dataService.setData('work_package_standard_id', selectedWPSId);
      this.dataService.setData('work_package_items', selectedWPSIItems);
      this.dataService.setData('package_name', this.selectedKeyword.name);
      this.toast.success('Section saved successfully', 'SUCCESS', 4000);
      // this.router.navigate(['/cost-estimation']);
    } else {
      this.toast.warning('Please select a work package.', 'WARNING', 4000);
    }
  }

  // Navigate back to the previous page
  navigatetoPreviousPage() {
    this.location.back();
  }



  openDialog(
    enterAnimationDuration: string,
    exitAnimationDuration: string,
    workPackageStandardId: number
  ): void {
    const dialogRef = this.dialog.open(DialogAnimationsExampleDialog, {
      width: '1555px',
      height: '700px',
      autoFocus: false,
      enterAnimationDuration,
      exitAnimationDuration,
      data: { workPackageStandardId },
    });

    // Listen for the dialog close event
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // If result is true, fetch the latest WPSI items
        this.getAllWPSI();
      }
    });
  }
}

@Component({
  templateUrl: './manual-generated-dialog.html',
  styleUrl: './manual-generated.component.css',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    RichTextEditorComponent,
    CommonModule,
    FormsModule,
  ],
})
export class DialogAnimationsExampleDialog {
  readonly dialogRef = inject(MatDialogRef<DialogAnimationsExampleDialog>);
  private projectsService = inject(ProjectsService);

  resetRichTextEditor = false;

  itemName = '';
  description = '';
  workPackageStandardId: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toast: NgToastService
  ) {
    // Access the passed keyword.id
    this.workPackageStandardId = data.workPackageStandardId;
  }

  addMitigationStrategy(content: string) {
    this.description = content;
  }

  saveData() {
    if (this.itemName && this.description) {
      const dataToSubmit = new FormData();
      dataToSubmit.append('name', this.itemName);
      dataToSubmit.append('description', this.description);
      dataToSubmit.append(
        'work_package_standard_id',
        this.workPackageStandardId.toString()
      );

      // Make API call to save the data
      this.projectsService.addWorkPackageStandardItem(dataToSubmit).subscribe({
        next: () => {
          this.toast.success(
            'Sub Work Package created successfully',
            'SUCCESS',
            4000
          );
          this.dialogRef.close(true); // Pass 'true' to signal success
        },
        error: (error: any) => {
          this.toast.danger(error.error.message, 'DANGER', 4000); // Show error toast
        },
      });
    } else {
      this.toast.danger('Please fill in all fields.', 'DANGER', 4000); // Show error toast
    }
  }
 
}
